export function isTruthy(field: any): boolean {
  return field === 'true' || field === true;
}
